import React, {useState, useEffect, useContext} from "react";
import styled, {createGlobalStyle, css} from "styled-components";
import {rem} from "polished";
import Modal from "react-modal";
import QuoteModalForm from "./QuoteModalForm";
import {SketchfabContext} from "../Sketchfab/SketchfabContext";

const GlobalStyle = createGlobalStyle`
  .ReactModal__Overlay {
    opacity: 0;
    transition: opacity 0.3s;
  }

  .ReactModal__Overlay--after-open {
    opacity: 1;

    .ReactModal__Content {
      min-height: auto !important;
      opacity: 1;
      transform: translateY(0);
    }
  }

  .ReactModal__Overlay--before-close {
    opacity: 0;

    .ReactModal__Content {
      opacity: 0;
      transform: translateY(${rem(20)});
      transition: opacity 0.3s 0s, transform 0.3s 0s;
    }
  }

  .ReactModal__Content {
    opacity: 0;
    transform: translateY(${rem(20)});
    transition: opacity 0.3s 0.2s, transform 0.3s 0.2s;
  }
`;

const QuoteModalContent = styled.div`
  height: 100%;
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  position: relative;

  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: 57% 43%;
  }
`

const QuoteModalImage = styled.img`
  width: 100%;
  object-fit: cover;
  height: 100%;

  @media (max-width: 767px) {
    max-height: 300px;
  }
`

const QuoteButton = styled.button`
  background: #CC6F4C;
  width: 100%;
  padding: ${rem(14)};
  border: 0;
  appearance: none;
  color: white;
  font-size: 20px;
  border-radius: 5px;
  cursor: pointer;
  font-family: sans-serif;
  transition: 0.3s;

  &:hover {
    background: #231914;
  }

  &[disabled] {
    opacity: 0.2;
    cursor: not-allowed;
  }

  ${({outlined}) =>
          outlined &&
          css`
            background: white;
            color: #000;
            box-shadow: inset 0 0 0 2px #000;
          `}
  &:focus {
    outline: none;
  }
`;
const QuoteModal = ({ onAddToCart, title }) => {
    const [modalIsOpen, setIsOpen] = useState(false);
    const [screenShotImage, setScreenShotImage] = useState('')
    const {api, ready} = useContext(SketchfabContext);

    function openModal() {
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }

    useEffect(() => {
        Modal.setAppElement(document.querySelector("body"));
    }, []);

    useEffect(() => {
        if (modalIsOpen && api && ready) {
            api.getScreenShot(800, 800, 'image/png', (err, result) => {
                if (!err) {
                    setScreenShotImage(result)
                }
            });
        }
    }, [modalIsOpen, ready])

    const customStyles = {
        content: {
            padding: 0,
            borderRadius: 0,
            minHeight: rem(688),
            width: rem(940),
            maxWidth: "90%",
            maxHeight: "90%",
            overflow: "auto",
            border: 0,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            position: "relative",
            background: "none",
            margin: "auto auto",
        },
        overlay: {
            display: "flex",
            background: "rgba(0,0,0,0.25)",
            backdropFilter: "blur(4px)",
            zIndex: 100,
        },
    };

    return (
        <React.Fragment>
            <GlobalStyle/>

            <QuoteButton onClick={openModal} id="quote-form-open">Request a Quote</QuoteButton>

            <Modal
                closeTimeoutMS={300}
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
            >
                <QuoteModalContent>
                    <QuoteModalImage src={screenShotImage}/>
                    <QuoteModalForm screenShot={screenShotImage} title={title} closeModal={closeModal} submitQuoteForm={onAddToCart}/>
                </QuoteModalContent>
            </Modal>
        </React.Fragment>
    );
};

export default QuoteModal;
